import IPage from "../../../interfaces/page";
import UserUpdatePasswordFormComponent from "../../Components/UserUpdatePassword/UserUpdatePasswordForm.component";
import Width800Layout from "../../layouts/Width800/Width800.layout";

const UserUpdatePasswordPage: React.FC<IPage> = () => {
    return <Width800Layout component={UserUpdatePasswordFormComponent} />
}

export default UserUpdatePasswordPage;